import { render, staticRenderFns } from "./OrderColumnReferredBy.vue?vue&type=template&id=60c944d8&"
import script from "./OrderColumnReferredBy.vue?vue&type=script&lang=ts&"
export * from "./OrderColumnReferredBy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports